module.exports = __webpack_public_path__ + "static/media/quotes.417def3d.svg";